import axios from "axios";
import token from "./token";
import store from "../store/index"
const url = process.env.NODE_ENV === 'production' ? 'https://api.eonwms.com/' : 'https://apisandbox.eonwms.com/';
// const url = "http://localhost:3000/";

const instance = axios.create({
  baseURL: `${url}`,
  headers: {
    "Content-type": "application/json"
  }
});

instance.interceptors.request.use(
  (config) => {
    store.state.loaderProps.visible = true;
    const _token = token.getLocalAccessToken();
    if (_token) {
      (config.headers ??= {}).Authorization = _token;
    }
    return config;
  },
  (error) => {
    store.state.loaderProps.visible = false;
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res) => {
    store.state.loaderProps.visible = false;
    return res;
  },
  async (err) => {
    store.state.loaderProps.visible = false;
    const originalConfig = err.config;
    if (err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;
        token.removeTokens();
      }
      if (err.response.status === 403 && err.response.data) {
        return Promise.reject(err.response.data);
      }
    }
    return Promise.reject(err);
  }
);

export default instance;